export class HistoricoServicoTomadoDialogData {
  idNFSeEntrada: number;
  /** Subtítulo do modal: "NFS-e {numero} / {serie}". */
  titulo = '';
}
